import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaGlobe, FaCamera, FaPlane, FaLaptopCode, FaChartLine, FaMapMarkedAlt, FaQuoteLeft, FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import SEOHelmet from '../../components/SEOHelmet';
import { BreadcrumbSchema } from '../../components/SchemaMarkup';
import { mainPageSeo } from '../../data/seoData';
import ProtectedImage from '../../components/ProtectedImage';
import './About.css';

// Photo Gallery Component
const PhotoGallery = () => {
  // Shuffle function for randomizing images
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const baseGalleryImages = [
    {
      id: 1,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720069/IMG_2014_qw8bqg.jpg',
      title: ''
    },
    {
      id: 2,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720078/NTWF3943_nipoj6.jpg',
      title: ''
    },
    {
      id: 3,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720074/IMG_2275_lany4d.jpg',
      title: ''
    },
    {
      id: 4,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720070/IMG_0617_t3qerd.jpg',
      title: ''
    },
    {
      id: 5,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720066/IMG_1998_dtkdya.jpg',
      title: ''
    },
    {
      id: 6,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720074/IMG_1833_dd1sr9.jpg',
      title: ''
    },
    {
      id: 7,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720067/IMG_2019_pctksb.jpg',
      title: ''
    },
    {
      id: 8,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720071/IMG_2245_rpdamw.jpg',
      title: ''
    },
    {
      id: 9,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720066/IMG_2022_wh6wd7.jpg',
      title: ''
    },
    {
      id: 10,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720074/IMG_2352_ukjlh6.jpg',
      title: ''
    },
    {
      id: 11,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720075/IMG_1544_gznado.jpg',
      title: ''
    },
    {
      id: 12,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720081/IMG_20230626_092639_lgimyo.jpg',
      title: ''
    },
    {
      id: 13,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720082/IMG_20230626_092641_m7brvz.jpg',
      title: ''
    },
    {
      id: 14,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720074/IMG_1282_u2hvzp.jpg',
      title: ''
    },
    {
      id: 15,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720081/IMG_20230626_092606__01_gf6hku.jpg',
      title: ''
    },
    {
      id: 16,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720071/IMG_2524_y6vxg6.jpg',
      title: ''
    },
    {
      id: 17,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720075/IMG_1488_obeu4a.jpg',
      title: ''
    },
    {
      id: 18,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720072/IMG_0297_q7sbg2.jpg',
      title: ''
    },
    {
      id: 19,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720072/IMG_0297_q7sbg2.jpg',
      title: ''
    },
    {
      id: 20,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720079/IMG_0058_e22yuz.jpg',
      title: ''
    },
    {
      id: 21,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720078/IMG_0073_ecyadn.jpg',
      title: ''
    },
    {
      id: 22,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720077/IMG_9787_ykitd9.jpg',
      title: ''
    },
    {
      id: 23,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720065/IMG_2072_eu0jae.jpg',
      title: ''
    },
    {
      id: 24,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720076/IMG_0425_becwhb.jpg',
      title: ''
    },
    {
      id: 25,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720065/Copy_of_IMG_0425_wb3voj.jpg',
      title: ''
    },
    {
      id: 26,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720069/IMG_9805_aihxte.jpg',
      title: ''
    },
    {
      id: 27,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720078/IMG_9804_j176le.jpg',
      title: ''
    },
    {
      id: 28,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720076/IMG_9908_f6gnsw.jpg',
      title: ''
    },
    {
      id: 29,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720077/IMG_9778_weqtpx.jpg',
      title: ''
    },
    {
      id: 30,
      url: 'https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720078/UQTM1029_rxvt13.jpg',
      title: ''
    },
  ];

  const [galleryImages] = useState(() => shuffleArray(baseGalleryImages));
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedImageId, setSelectedImageId] = useState(null);
  const [isAutoScroll, setIsAutoScroll] = useState(true);

  // Get the index of selected image
  const selectedImageIndex = selectedImageId ? galleryImages.findIndex(img => img.id === selectedImageId) : -1;

  const handlePrevImage = (e) => {
    e.stopPropagation();
    if (selectedImageIndex > 0) {
      setSelectedImageId(galleryImages[selectedImageIndex - 1].id);
    } else {
      setSelectedImageId(galleryImages[galleryImages.length - 1].id);
    }
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    if (selectedImageIndex < galleryImages.length - 1) {
      setSelectedImageId(galleryImages[selectedImageIndex + 1].id);
    } else {
      setSelectedImageId(galleryImages[0].id);
    }
  };

  const handleCloseModal = () => {
    setSelectedImageId(null);
  };

  useEffect(() => {
    if (!isAutoScroll) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % galleryImages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isAutoScroll, galleryImages.length]);

  return (
    <section className="section photo-gallery">
      <div className="container">
        <motion.h2 
          className="section-title scroll-reveal"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Photo Gallery
        </motion.h2>

        <div className="gallery-carousel">
          {/* Featured Carousel with Center Focus */}
          <div
            className="carousel-wrapper"
            onMouseEnter={() => setIsAutoScroll(false)}
            onMouseLeave={() => setIsAutoScroll(true)}
          >
            {/* Left Arrow */}
            <button 
              className="carousel-arrow carousel-arrow-left"
              onClick={() => {
                setCurrentIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
                setIsAutoScroll(false);
              }}
            >
              &#10094;
            </button>

            {/* Carousel Container */}
            <div className="carousel-container">
              {galleryImages.map((image, index) => {
                let position = (index - currentIndex + galleryImages.length) % galleryImages.length;
                
                return (
                  <motion.div
                    key={image.id}
                    className={`carousel-card ${position === 0 ? 'center' : position === 1 ? 'right' : position === galleryImages.length - 1 ? 'left' : 'hidden'}`}
                    onClick={() => {
                      if (position === 0) {
                        setSelectedImageId(image.id);
                      } else {
                        setCurrentIndex(index);
                        setIsAutoScroll(false);
                      }
                    }}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                  >
                    <ProtectedImage 
                      src={image.url} 
                      alt={image.title}
                      style={{ width: '100%', height: '100%', display: 'block' }}
                      imgStyle={{ height: '100%', objectFit: 'cover', display: 'block' }}
                    />
                  </motion.div>
                );
              })}
            </div>

            {/* Right Arrow */}
            <button 
              className="carousel-arrow carousel-arrow-right"
              onClick={() => {
                setCurrentIndex((prev) => (prev + 1) % galleryImages.length);
                setIsAutoScroll(false);
              }}
            >
              &#10095;
            </button>
          </div>

          {/* Pagination Dots */}
          <div className="carousel-dots">
            {galleryImages.map((_, index) => (
              <motion.div
                key={index}
                className={`dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => {
                  setCurrentIndex(index);
                  setIsAutoScroll(false);
                }}
                whileHover={{ scale: 1.2 }}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedImageId !== null && galleryImages[selectedImageIndex] && (
          <motion.div
            className="lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleCloseModal}
          >
            <button
              className="lightbox-close"
              onClick={handleCloseModal}
              aria-label="Close lightbox"
            >
              <FaTimes />
            </button>

            <button
              className="lightbox-nav lightbox-prev"
              onClick={handlePrevImage}
              aria-label="Previous image"
            >
              <FaChevronLeft />
            </button>

            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <ProtectedImage 
                src={galleryImages[selectedImageIndex].url} 
                alt={galleryImages[selectedImageIndex].title}
                style={{ display: 'block' }}
                imgStyle={{ maxWidth: '90vw', maxHeight: '80vh', width: 'auto', height: 'auto', objectFit: 'contain', display: 'block' }}
              />
              <div className="lightbox-info">
                <p className="lightbox-counter">{selectedImageIndex + 1} / {galleryImages.length}</p>
              </div>
            </div>

            <button
              className="lightbox-nav lightbox-next"
              onClick={handleNextImage}
              aria-label="Next image"
            >
              <FaChevronRight />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

const About = () => {
  const aboutSeo = mainPageSeo.about;
  
  return (
    <div className="about-page">
      <SEOHelmet 
        title={aboutSeo.title}
        description={aboutSeo.description}
        keywords={aboutSeo.keywords}
        image={aboutSeo.image}
        url="https://safarnamah.in/about"
        type="website"
      />
      <BreadcrumbSchema items={[
        { name: 'Home', url: 'https://safarnamah.in' },
        { name: 'About', url: 'https://safarnamah.in/about' }
      ]} />
      
      <section className="about-hero">
        <div className="container">
          <motion.h1 
            className="scroll-reveal"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            About Safarnamah
          </motion.h1>
          <motion.p 
            className="hero-subtitle scroll-reveal"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            A Journey of Love, Adventure & Discovery
          </motion.p>
        </div>
      </section>

      <section className="section our-story">
        <div className="container">
          <div className="story-content">
            <motion.div 
              className="story-text scroll-reveal"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="quote-icon">
                <FaQuoteLeft />
              </div>
              <h2>Our Story</h2>
              <p className="lead">
                Every great journey begins with a single step, and ours began in 2018 when we, 
                Saket and Pallavi, discovered our shared passion for exploring the world together.
              </p>
              <p>
                What started as weekend getaways quickly evolved into a profound love for travel. 
                As a married couple balancing busy careers—Pallavi as a Software Developer at an MNC 
                and Saket as a Project Manager in a finance company—we found our escape, our joy, 
                and our inspiration in discovering new destinations across Asia.
              </p>
              <p>
                Between project deadlines and code deployments, we carved out time to explore hidden 
                temples in Cambodia, cruise through the emerald waters of Halong Bay, savor street food 
                in Bangkok's bustling markets, and watch sunrises from mountain peaks in Sri Lanka. 
                Each journey taught us something new—not just about the places we visited, but about 
                ourselves and our relationship.
              </p>
              <p>
                <strong>Safarnamah</strong> was born from our desire to share these experiences with 
                fellow travelers. What began as personal journals and photo albums transformed into a 
                comprehensive travel platform. We realized that our unique perspective—balancing full-time 
                careers while pursuing our passion for travel—resonated with many who dream of exploring 
                but worry about constraints of time and budget.
              </p>
              <p>
                Today, through Safarnamah, we curate authentic travel guides, share practical tips 
                based on real experiences, and inspire others to embark on their own adventures. 
                Because we believe that travel isn't a luxury reserved for the few—it's a mindset, 
                a choice, and a way of enriching life that's accessible to all who dare to dream.
              </p>
            </motion.div>

            <motion.div 
              className="story-highlight scroll-reveal"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <div className="highlight-card">
                <FaPlane className="highlight-icon" />
                <h3>Since 2018</h3>
                <p>Over 5 years of exploring Asia together</p>
              </div>
              <div className="highlight-card">
                <FaMapMarkedAlt className="highlight-icon" />
                <h3>9 Countries</h3>
                <p>From Dubai's skyscrapers to Bali's beaches</p>
              </div>
              <div className="highlight-card">
                <FaCamera className="highlight-icon" />
                <h3>Countless Memories</h3>
                <p>Stories captured, experiences shared</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="section meet-team">
        <div className="container">
          <motion.h2 
            className="section-title scroll-reveal"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Meet the Travelers
          </motion.h2>

          <div className="team-grid">
            <motion.div 
              className="team-card scroll-scale"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <div className="team-image" style={{ backgroundImage: 'url("https://res.cloudinary.com/dwpt0fteq/image/upload/v1763748459/IMG_0734_SnapseedCopy_rb1qdh.jpg")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="team-avatar-overlay"></div>
              </div>
              <div className="team-info">
                <h3>Saket Bundele</h3>
                <p className="team-role">
                  <FaChartLine /> Project Manager - Finance
                </p>
                <p className="team-bio">
                  The planner and organizer behind our adventures. With a background in finance 
                  and project management, Saket brings structure to our spontaneous travel dreams. 
                  He's the one researching destinations, managing budgets, and ensuring we make 
                  the most of every trip. His analytical mind combined with a love for adventure 
                  makes him the perfect travel companion.
                </p>
                <div className="team-passion">
                  <strong>Travel Style:</strong> Adventure seeker, history enthusiast, sunrise chaser
                </div>
              </div>
            </motion.div>

            <motion.div 
              className="team-card scroll-scale"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="team-image" style={{ backgroundImage: 'url("https://res.cloudinary.com/dwpt0fteq/image/upload/v1763720078/IMG_0073_ecyadn.jpg")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="team-avatar-overlay"></div>
              </div>
              <div className="team-info">
                <h3>Pallavi Korade</h3>
                <p className="team-role">
                  <FaLaptopCode /> Software Developer - MNC
                </p>
                <p className="team-bio">
                  The creative mind and storyteller of our duo. As a software developer, Pallavi 
                  brings technical expertise to Safarnamah's digital presence while infusing it 
                  with creativity and warmth. She captures the essence of each destination through 
                  her words and photographs, turning our experiences into inspiring travel stories.
                </p>
                <div className="team-passion">
                  <strong>Travel Style:</strong> Cultural explorer, foodie, photography lover
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <PhotoGallery />

      <section className="section about-values">
        <div className="container">
          <motion.h2 
            className="section-title scroll-reveal"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            What We Believe In
          </motion.h2>

          <div className="values-grid">
            <motion.div 
              className="value-card scroll-scale"
              whileHover={{ y: -8 }}
              transition={{ duration: 0.3 }}
            >
              <FaHeart className="value-icon" />
              <h3>Authentic Experiences</h3>
              <p>
                We believe in genuine travel experiences that connect you with local cultures, 
                communities, and traditions. No tourist traps—just real, meaningful encounters.
              </p>
            </motion.div>

            <motion.div 
              className="value-card scroll-scale"
              whileHover={{ y: -8 }}
              transition={{ duration: 0.3 }}
            >
              <FaGlobe className="value-icon" />
              <h3>Sustainable Travel</h3>
              <p>
                We're committed to responsible tourism that respects the environment, preserves 
                heritage sites, and supports local economies. Travel should leave places better 
                than we found them.
              </p>
            </motion.div>

            <motion.div 
              className="value-card scroll-scale"
              whileHover={{ y: -8 }}
              transition={{ duration: 0.3 }}
            >
              <FaCamera className="value-icon" />
              <h3>Visual Storytelling</h3>
              <p>
                Through captivating photography and vivid narratives, we bring destinations to life. 
                Every image tells a story, every story sparks wanderlust.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="section mission-vision">
        <div className="container">
          <div className="mission-grid">
            <motion.div 
              className="mission-card scroll-reveal"
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h3>Our Mission</h3>
              <p>
                To inspire and empower working professionals and couples to explore the world 
                without sacrificing their careers. We prove that with smart planning and the 
                right mindset, anyone can become a traveler.
              </p>
            </motion.div>

            <motion.div 
              className="mission-card scroll-reveal"
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h3>Our Vision</h3>
              <p>
                To build a community of mindful travelers who explore responsibly, share 
                generously, and inspire others to discover the transformative power of travel.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      <section className="section cta-section">
        <div className="container">
          <motion.div 
            className="cta-content scroll-reveal"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Join Our Journey</h2>
            <p>
              Follow along as we continue to explore, discover, and share the wonders of Asia. 
              Whether you're a seasoned traveler or planning your first trip, we're here to 
              guide and inspire you every step of the way.
            </p>
            <div className="cta-buttons">
              <Link to="/blog" className="btn btn-primary">Read Our Stories</Link>
              <Link to="/plan-trip" className="btn btn-secondary">Plan Your Trip</Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;
